import styles from './ChartItemInfo.css';
import { Image, TColors, UIText2 } from '@cian/ui-kit';
import { TConstantColors } from '@cian/ui-kit/colors/constant';

interface IChartInfoItem {
  src: string;
  text: string;
  color: TColors | TConstantColors;
}
export function ChartItemInfo({ src, text, color }: IChartInfoItem) {
  return (
    <div className={styles['container']}>
      <div className={styles['img']}>
        <Image src={src} />
      </div>
      <UIText2 fontWeight="400" color={color}>
        {text}
      </UIText2>
    </div>
  );
}
